import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "./DsText";
import { tokens } from "./tokens";

// tone: "warning" | "success"
const Banner = ({ tone = "warning", children, testID }) => {
  const isSuccess = tone === "success";
  return (
    <View
      testID={testID}
      style={[
        styles.banner,
        {
          backgroundColor: isSuccess ? tokens.successBg : tokens.warningBg,
          borderColor: isSuccess ? tokens.successBorder : tokens.warningBorder,
        },
      ]}
    >
      <Text
        variant="caption_2"
        style={[
          styles.text,
          { color: isSuccess ? tokens.successText : tokens.warningText },
        ]}
      >
        {children}
      </Text>
    </View>
  );
};

export default Banner;

const styles = StyleSheet.create({
  banner: {
    marginHorizontal: tokens.spacing.large,
    marginBottom: tokens.spacing.medium,
    padding: tokens.spacing.medium,
    borderWidth: 1,
    borderRadius: tokens.radius.md,
  },
  text: { fontSize: 13, lineHeight: 18 },
});
